import { useCallback, useEffect, useRef, useState } from 'react';
import { convertToDayJs, getCurrentTimeDiff, isNil } from 'shared/src/utils';

export const useRemainTimeTextFormat = (time: string | null) => {
  const timeIntervalRef = useRef<number>(null);
  const [remainText, setRemainText] = useState<string>('');
  const [isTimeOver, setIsTimeOver] = useState<boolean>(false);
  const [isOneHourRemaining, setIsOneHourRemaining] = useState<boolean>(false);

  const getRemainTime = useCallback(() => {
    if (isNil(time)) return '';

    const limitTime = convertToDayJs(time);

    const diffSecond = getCurrentTimeDiff(limitTime, 'second');
    const diffHourText = Math.abs(getCurrentTimeDiff(limitTime, 'hour'));
    const diffMinute = Math.abs(getCurrentTimeDiff(limitTime, 'minute'));
    const diffMinuteText = diffMinute - diffHourText * 60;
    const diffSecondText =
      Math.abs(getCurrentTimeDiff(limitTime, 'second')) - diffMinute * 60;

    const isTimeOver = diffSecond > 0;

    const diffDay = Math.abs(getCurrentTimeDiff(limitTime, 'day'));
    const text =
      diffHourText >= 24
        ? `${diffDay}일`
        : `${diffHourText < 10 ? `0${diffHourText}` : diffHourText} : ${diffMinuteText < 10 ? `0${diffMinuteText}` : diffMinuteText} : ${diffSecondText < 10 ? `0${diffSecondText}` : diffSecondText}`;
    setIsTimeOver(isTimeOver);
    setRemainText(text);
    if (!isTimeOver) {
      setIsOneHourRemaining(diffHourText === 0);
    } else {
      if (timeIntervalRef.current) clearInterval(timeIntervalRef.current);
    }
  }, [time]);

  useEffect(() => {
    if (isNil(time)) {
      return;
    }

    getRemainTime();

    timeIntervalRef.current = setInterval(getRemainTime, 1000);

    return () => {
      if (timeIntervalRef.current) clearInterval(timeIntervalRef.current);
    };
  }, [getRemainTime, time]);

  return {
    text: remainText,
    isTimeOver,
    isOneHourRemaining,
  };
};
